import React from 'react';
import { Icon } from '@iconify/react';
import { HighlightedTextIcon } from 'components/molecules';
import { AboutSectionContentProps } from 'components/organisms/About/types';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';

const Text = () => (
    <>
        私は<HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {', '} <HighlightedTextIcon as="a" href="https://www.typescriptlang.org/" className="mx-2" icon={<img src="/img/typescript.svg" alt="TypeScript" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">TypeScript</span>
        </HighlightedTextIcon>、そして <HighlightedTextIcon as="a" href="https://supabase.com/" className="mx-2" icon={<img src="/img/supabase.svg" alt="Supabase" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Supabase</span>
        </HighlightedTextIcon>を使用して、最先端のフルスタックWebソリューションを設計しています。私の専門は、最新のWebアプリケーション向けのレスポンシブなユーザーインターフェースと堅牢なバックエンドの開発です。
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {' '}と
        <HighlightedTextIcon
            as="a"
            href="https://tailwindcss.com"
            className="mx-2"
            icon={<Icon icon={tailwindcssIcon} />}
        >
            <span className="font-bold text-gray-800">TailwindCSS</span>
        </HighlightedTextIcon>
        {' '}と
        <HighlightedTextIcon
            as="a"
            href="https://ui.shadcn.com/"
            className="mx-2"
            icon={<img src="/img/shadcn.svg" alt="ShadCN" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">ShadCN/UI</span>
        </HighlightedTextIcon>
        を使用して、本番環境に対応したWebアプリを構築することを楽しんでいます。

        {'. '}また、
        <HighlightedTextIcon as="a" href="https://nextjs.org/" className="mx-2" icon={<img src="/img/nextjs.svg" alt="Next.js" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Next.js</span>
        </HighlightedTextIcon>を使用したWebアプリ構築の経験もあります。これらのツールを約<span className="font-bold text-gray-800">2年間</span>使用しており、これらを使用してアプリを構築することに自信を持っています。私は

        <HighlightedTextIcon as="a" href="https://weabers.com/" className="mx-2" icon={<img src="/img/weabers.avif" alt="Weabers" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Weabers</span>
        </HighlightedTextIcon>でWeb開発者としてインターンシップを完了しました{'. '} 私は<HighlightedTextIcon as='a' href="https://www.sports.com" className="mx-2" icon={<img src="/img/sports.svg" alt="sports" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">スポーツ愛好家</span>
        </HighlightedTextIcon>でもあり、<HighlightedTextIcon
            as='a'
            href="https://robocopplays.netlify.app/"
            className="mx-2"
            icon={<img src="/img/gamer.svg" alt="gamer" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">ゲーマー</span>
        </HighlightedTextIcon>でもあります。
    </>
);

const about: AboutSectionContentProps = {
    text: <Text />,
};

export default about;
